// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer {
  opacity: 1 !important;
  clear: both;
  padding-left: 16px;
  padding-right: 16px;
  padding-bottom: 16px;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.footer--pin__button_primary {
  border-radius: 8px;
  background-color: var(--btn-bg-primary);
  color: var(--escala-de-grises-gris-0, #FFF);
}

.footer--pin__button_primary-disabled {
  color: var(--color-disabled-btn);
  background-color: var(--bg-color-disabled-btn) !important;
}

.footer--pin__button_link {
  color: var(--light-gray-500);
  line-Height: 16px;
  text-decoration: none;
  cursor: pointer;
  font-size: 14px;
}

.footer--pin__button_secundary {
  display: flex;
  width: 344px;
  padding: 10px 24px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 8px;
  border: 1px solid var(--color-secundario-azul-800, #004A94);
}`, "",{"version":3,"sources":["webpack://./src/infraestructure/components/templates/footer/style.css"],"names":[],"mappings":"AAAA;EACG,qBAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AACH;;AAGA;EACI,kBAAA;EACA,uCAAA;EACA,2CAAA;AAAJ;;AAGA;EACI,gCAAA;EACA,yDAAA;AAAJ;;AAIA;EACI,4BAAA;EACA,iBAAA;EACA,qBAAA;EACA,eAAA;EACA,eAAA;AADJ;;AAIA;EACI,aAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,2DAAA;AADJ","sourcesContent":[".footer {\n   opacity: 1 !important;\n   clear: both;\n   padding-left: 16px; \n   padding-right: 16px; \n   padding-bottom: 16px;\n   display:flex;\n   flex-direction: column;\n   gap: 24px;\n}\n\n\n.footer--pin__button_primary {\n    border-radius: 8px;\n    background-color: var(--btn-bg-primary);\n    color: var(--escala-de-grises-gris-0, #FFF);\n}\n\n.footer--pin__button_primary-disabled {\n    color: var(--color-disabled-btn);\n    background-color: var(--bg-color-disabled-btn) !important;\n  }\n\n\n.footer--pin__button_link {\n    color: var(--light-gray-500);\n    line-Height: 16px;\n    text-decoration: none;\n    cursor: pointer;\n    font-size: 14px;\n}\n\n.footer--pin__button_secundary {\n    display: flex;\n    width: 344px;\n    padding: 10px 24px;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    gap: 8px;\n    border-radius: 8px;\n    border: 1px solid var(--color-secundario-azul-800, #004A94);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
